import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type saveData = {
    id?: any;
  };
  
  export const deleteUser = ({
   id
  }: saveData) => {
        return axios.delete(`/superAdmin/delete-contact/${id}`);
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof deleteUser>;
  };
  
  export const useDeleteContact = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'Contact deleted successfully.',
        });
      },
      ...config,
      mutationFn: deleteUser,
    });
  };
  
